// semeia-disable-reexport
import type { AuthenticationContext } from "parog-web/contexts/authentication-context";
import type MedicModel from "parog-web/models/medic";
import type { CardReaderAdapter } from "./card-reader-adapter";
import type { DmpAdapter } from "./dmp-adapter";
import type { InsiAdapter } from "./insi-adapter";

export abstract class CnamManagerAdapter {
  declare authenticationContext: AuthenticationContext;
  declare cardReaderAdapter: CardReaderAdapter;
  declare dmpAdapter: DmpAdapter;
  declare insiAdapter: InsiAdapter;
  declare name: string;
  declare medic: MedicModel;
  declare requestManager;
  onDismiss?(): Promise<void>;
}
